import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'reactstrap';
import Select from 'react-select';
import AddressInputAutoComplete from '../../../../common/AddressInputAutoComplete';
import { modifyObject } from '../../../../../helpers/modifyObject';
import Close from '../../../../common/ui/Close';
import FormActionButtons from '../../../../common/forms/FormActionButtons';
import Validator from '../../../../common/forms/Validator';
import ErrorMessage from '../../../../common/forms/ErrorMessage';

export default class AddLocationModal extends Validator {
  static propTypes = {
    isOpen: PropTypes.bool.isRequired,
    closeModal: PropTypes.func.isRequired,
    locationsList: PropTypes.array.isRequired,
    addLocationToJob: PropTypes.func.isRequired
  };

  state = {
    name: '',
    selectedLocationType: null,
    addressInfo: {
      address: '',
      state: '',
      city: '',
      zip: '',
      coordinates: ''
    }
  };

  validationRules = {
    name: { required: true },
    selectedLocationType: { required: true },
    address: { required: true },
    state: { required: true },
    city: { required: true },
    zip: { required: true }
  };

  handleChangeName = event => {
    this.setState({
      name: event.target.value
    });
  };

  handleChangeLocationType = selectedLocationType => {
    this.setState({ selectedLocationType });
  };

  handleChangeAddress = addressInfo => {
    const { address, city, state, zip, address_coordinates, time_zone_id } = addressInfo;
    this.setState({
      addressInfo: {
        address: address || '',
        city: city || '',
        state: state || '',
        zip: zip || '',
        coordinates: address_coordinates,
        time_zone_id
      }
    });
  };

  clearForm = () => {
    this.setState({
      name: '',
      selectedLocationType: null,
      addressInfo: {
        address: '',
        state: '',
        city: '',
        zip: '',
        coordinates: '',
        time_zone_id: ''
      }
    });
  };

  closeModal = () => {
    this.clearForm();
    this._resetErrors();
    this.props.closeModal();
  };

  _validate = () => {
    const { name, selectedLocationType, addressInfo: { address, city, state, zip } } = this.state;
    return this.validate(this.validationRules, { name, selectedLocationType, address, city, state, zip });
  };

  submitAddLocation = e => {
    e.preventDefault();
    this._resetErrors();
    if (!this._validate()) {
      return;
    }
    const { name, addressInfo, selectedLocationType } = this.state;
    const { address, state, city, zip, coordinates, time_zone_id } = addressInfo;
    const locationData = modifyObject({
      location_name: name,
      address,
      state,
      city,
      zip,
      coordinates,
      job_location_type_id: selectedLocationType.value,
      time_zone_id,
      id: Date.now() // temporary id, only for redux store
    });
    this.props.addLocationToJob(locationData).then(this.clearForm);
  };

  render () {
    const { isOpen, closeModal, locationsList } = this.props;
    const { name, selectedLocationType, addressInfo } = this.state;
    const { city, state, zip } = addressInfo;
    const options = locationsList.map(location => ({
      label: location.label_en,
      value: location.id
    }));
    const errors = this.validationErrors;
    return (
      <Modal isOpen={isOpen}>
        <div className='modal-header flex-wrap'>
          <div className='modal-title'>Add New Location</div>
          <Close onClick={closeModal} />

          <div className='text-muted w-100'>(This location will only be available for this job)</div>
        </div>

        <form className='modal-body' onSubmit={this.submitAddLocation}>
          <div className='form-group'>
            <label className='label' htmlFor='new-location-name-input'>Name</label>
            <input
              id='new-location-name-input'
              className='input'
              value={name}
              onChange={this.handleChangeName}
            />
            <ErrorMessage errorText={errors.name} />
          </div>

          <div className='form-group'>
            <label className='label' htmlFor='new-location-select-type-id'>Type</label>
            <Select
              id='new-location-select-type-id'
              className='new-location-select-type'
              onChange={this.handleChangeLocationType}
              options={options}
              placeholder='Choose'
              value={selectedLocationType}
            />
            <ErrorMessage errorText={errors.selectedLocationType} />
          </div>

          <div className='form-group'>
            <label className='label' htmlFor='addressInput'>Address</label>
            <AddressInputAutoComplete
              noLabel
              showOnlyAddress
              addressInfo={addressInfo}
              handleAddressChange={this.handleChangeAddress}
            />
            <ErrorMessage errorText={errors.address} />
          </div>

          <div className='form-group'>
            <label className='label'>City</label>
            <input className='input' value={city} readOnly />
            <ErrorMessage errorText={errors.city} />
          </div>

          <div className='form-group'>
            <label className='label'>State</label>
            <input className='input' value={state} readOnly />
            <ErrorMessage errorText={errors.state} />
          </div>

          <div className='form-group'>
            <label className='label'>Zip</label>
            <input className='input' value={zip} readOnly />
            <ErrorMessage errorText={errors.zip} />
          </div>

          <FormActionButtons onClickCancel={this.closeModal} submitTitle='Add' />
        </form>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/app/createJob/createJob/LocationScheduleStep/AddLocationModal.js